import React from "react";

export const LogoMark = ({ size = 40, className = "" }) => (
  <img
    src="/images/logo-sg.png"
    alt="SG monogram — A View From The Top"
    width={size}
    height={size}
    className={`shrink-0 ${className}`}
  />
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark size={compact ? 34 : 42} />
    <span className="leading-none">
      <span
        className={`font-cinzel block text-gold-gradient tracking-[0.14em] ${
          compact ? "text-[13px]" : "text-sm sm:text-base"
        }`}
      >
        A VIEW FROM THE TOP
      </span>
      {!compact && (
        <span className="hidden sm:block text-[10px] uppercase tracking-[0.3em] text-[#8A99B5] mt-1.5">
          Susan Grau · Live at the Saban
        </span>
      )}
    </span>
  </span>
);
